import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import Button from '../ui/Button';
import SendNotificationModal from './SendNotificationModal';

const NotificationButton = ({ selectedUsers = [], allUsers = [], committees = [] }) => {
  const { isAdmin } = useAuth();
  const { getResponsiveValue } = useTheme();
  const [showModal, setShowModal] = useState(false);

  // Only show for admin users
  if (!isAdmin()) {
    return null;
  }

  const buttonSize = getResponsiveValue({
    mobile: 'sm',
    desktop: 'md'
  });

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <Button
        onClick={handleOpenModal}
        variant="primary"
        size={buttonSize}
        className="flex items-center space-x-2"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M15 17h5l-5 5l-5-5h5V7a1 1 0 011-1h1a1 1 0 011 1v10z"
          />
        </svg>
        <span>Send Notification</span>
      </Button>

      <SendNotificationModal
        isOpen={showModal}
        onClose={handleCloseModal}
        selectedUsers={selectedUsers}
        allUsers={allUsers}
        committees={committees}
      />
    </>
  );
};

export default NotificationButton;